module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMDAwY2QiIGQ9Ik0wIDMyMC4zNDRoNjQwVjQ4MEgweiIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMTYwLjY4OGg2NDB2MTU5LjY1NkgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwY2QwMCIgZD0iTTAgMGg2NDB2MTYwLjY4OEgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/sl.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/sl.svg
// module chunks = 0